import {call, put, takeLatest} from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import {CurrenciesAction} from "../actions";
import * as currenciesApi from "../api/currencies";
import {toastr} from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherCurrencies() {
  yield takeLatest(types.GET_CURRENCIES_REQUEST, worker);
}

function fetch() {
  return currenciesApi.get();
}

function* worker() {
  try {
    const response = yield call(fetch);
    yield put(CurrenciesAction.getSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(CurrenciesAction.getFailure(error));
  }
}
